export const DEFAULT_ADDRESS = {
  streetAddress: '1000 South Broadway',
  city: 'Denver',
  state: 'CO',
  zipcode: '80209'
}
